export default "__VITE_ASSET__3BOD8ALB__"